export default "__VITE_ASSET__CVY_IlFJ__"